<template>
  <span class="c-badge" :class="color ? `c-badge--${color}` : ''">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    // green | blue | purple | orange | teal | red | '' (default gray)
    color: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.c-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(0, 0, 0, .08);
  background: rgba(0, 0, 0, .03);
  color: rgba(0, 0, 0, .65);

  &--green {
    background: rgba(34, 197, 94, .10);
    border-color: rgba(34, 197, 94, .25);
    color: rgba(21, 128, 61, .95);
  }

  &--blue {
    background: rgba(37, 99, 235, .08);
    border-color: rgba(37, 99, 235, .22);
    color: rgba(30, 64, 175, .95);
  }

  &--purple {
    background: rgba(124, 58, 237, .08);
    border-color: rgba(124, 58, 237, .22);
    color: rgba(109, 40, 217, .95);
  }

  &--orange {
    background: rgba(245, 158, 11, .10);
    border-color: rgba(245, 158, 11, .25);
    color: rgba(180, 83, 9, .95);
  }

  &--teal {
    background: rgba(12, 166, 120, .10);
    border-color: rgba(12, 166, 120, .25);
    color: rgba(5, 110, 80, .95);
  }

  &--red {
    background: rgba(239, 68, 68, .10);
    border-color: rgba(239, 68, 68, .25);
    color: rgba(185, 28, 28, .95);
  }
}
</style>
